import { createStyles, makeUiStyles, Theme } from '../../styles/styles';
import { fontDisplay, StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    position: 'static',
    transform: 'none',
    transition: 'none',
    font: fontDisplay('normal', theme.fontSize.base, 24),
    color: theme.color.greys[80],
    '&.Mui-focused': {
      color: theme.color.greys[80],
    },
  },
}), { name: 'FieldLabel', index: StylesIndexInjections.UI_ATOMS });
